export default {
  'userActivity.title': '操作记录',
  'userActivity.userSelect.placeholder': '用户操作',
  'userActivity.column.void': '作废',

  'userActivity.column.created_at': '创建时间',
  'userActivity.column.activity_name': '用户操作',
  'userActivity.column.order_number': '订单号',
  'userActivity.column.operator_name': '操作人',
  'userActivity.column.approver_name': '授权人',
  'userActivity.column.items': '菜品',
  'userActivity.column.price': '金额',
  'userActivity.column.reason': '原因',
  'userActivity.column.notes': '备注',
  'userActivity.column.device_serial_number': '设备序列号',
  'userActivity.column.activity_content': '操作内容',
  'userActivity.column.operation_mode': '操作模式',

  'userActivity.operationMode.online': '在线',
  'userActivity.operationMode.offline': '离线',

  'userActivity.scheduleSendDish': '延迟送厨，{scheduled_duration}分钟',
  'userActivity.activityType.send_dish_item': '送厨',
  'userActivity.activityType.add_payment': '支付',
  'userActivity.activityType.apply_order_promotion': '参加促销',
  'userActivity.activityType.finish_order': '关单',
  'userActivity.activityType.void_order': '作废订单',
  'userActivity.activityType.void_dish_item': '作废菜品',
  'userActivity.activityType.transfer_order': '转移订单',
  'userActivity.activityType.merge_order': '合并订单',
  'userActivity.activityType.note_order': '整单备注',
  'userActivity.activityType.change_order_employee': '更改服务员',
  'userActivity.activityType.update_dish_item_price': '菜品改价',
  'userActivity.activityType.update_dish_item_quantity': '菜品改数量',
  'userActivity.activityType.note_dish_item': '菜品备注',
  'userActivity.activityType.discount_dish_item': '菜品打折',
  'userActivity.activityType.transfer_dish_item': '转移菜品',
  'userActivity.activityType.remove_exempt_dish_item_order_discount': '取消菜品免于整单折扣',
  'userActivity.activityType.exempt_dish_item_order_discount': '菜品免于整单折扣',
  'userActivity.activityType.exempt_dish_item_tax': '菜品免税',
  'userActivity.activityType.remove_exempt_dish_item_tax': '取消菜品免税',
  'userActivity.activityType.delete_dish_item': '取消菜品',
  'userActivity.activityType.reopen': '重开订单',
  'userActivity.activityType.confirm_order': '接单',
  'userActivity.activityType.cancel_order': '取消订单',
  'userActivity.activityType.create_order': '开单',
  'userActivity.activityType.exempt_order_tax': '整单免税',
  'userActivity.activityType.remove_exempt_order_tax': '取消整单免税',
  'userActivity.activityType.offline_order_sync': 'offline同步',
  'userActivity.activityType.open_cash_box': '开钱箱',
  'userActivity.activityType.refund': '退款',
  'userActivity.activityType.update_tips': '编辑小费',
  'userActivity.activityType.cancel_payment': '取消支付',
  'userActivity.activityType.split_order_by_check': '分单',
  'userActivity.activityType.reprint_order': '重新打印',
  'userActivity.activityType.print_order': '打印',
  'userActivity.activityType.delete_order_fee': '删除费用',
  'userActivity.activityType.add_order_fee': '添加费用',
  'userActivity.activityType.edit_order_fee': '编辑费用',
  'userActivity.activityType.update_order_fees': '更新订单的所有费用',
  'userActivity.activityType.update_order_discount': '整单折扣',
  'userActivity.activityType.change_service_type': '更改服务类型',
  'userActivity.activityType.apply_order_point': '积分兑换',
  'userActivity.activityType.quick_menu_edit': '快捷编辑菜单',
  'userActivity.activityType.update_decorated_menu': '更改平板点餐Pro版',
  'userActivity.activityType.void_dish_customization': '作废菜品附加选项',
  'userActivity.activityType.retry_print': '重试打印',
  'userActivity.activityType.reset_ticket': '重置票号',
  'userActivity.activityType.floor_plan_section_editing': '平面图区域编辑',
  'userActivity.activityType.update_time_log': '更改打卡记录',
  'userActivity.activityType.delete_time_log': '删除打卡记录',
  'userActivity.activityType.restaurant_setting': '餐厅设置',
  'userActivity.activityType.update_role_permissions': '更改角色的权限点',

  'userActivity.activityGroup.shopping_cart': '购物车',
  'userActivity.activityGroup.order': '订单',
  'userActivity.activityGroup.payment': '支付',
  'userActivity.activityGroup.print': '打印',
  'userActivity.activityGroup.other': '其他',
};
